export default {"src":"/_next/static/media/recul_heure.eb0682a4.svg","height":52,"width":67,"blurWidth":0,"blurHeight":0};